import {
    CreateUserUseCase,
    GetUsersUseCase,
    GetUserUseCase,
    UpdateUserUseCase,
} from '@User/Domain/UseCases'
import { DisableUserUseCase } from '@User/Domain/UseCases/DisableUser'
import { EnableUserUseCase } from '@User/Domain/UseCases/EnableUser'
export const Register = {
    UseCaseCreateUser: CreateUserUseCase,
    UseCaseGetUsers: GetUsersUseCase,
    UseCaseGetUser: GetUserUseCase,
    UseCaseUpdateUser: UpdateUserUseCase,
    UseCaseDisableUser: DisableUserUseCase,
    UseCaseEnableUser: EnableUserUseCase,
}
